import React from 'react';
import { Modal } from 'react-bootstrap';
import closeIcon from '../../assets/images/adifund/popup-close-dark.svg';
import '../../assets/scss/adifund.scss';

/**
 * Adifund sponsorship popup — version 1.
 * Figma: "Frame 1774" (40:20271) inside Homepage-African (40:19993).
 *
 * Shown from the (i) on the homepage card only. The Manage Subscription screen
 * in settings renders the card with `variant="settings"`, which drops the (i),
 * so no popup is reachable from there. (Popup v2 was removed — this is the only
 * Adifund popup that ships.)
 *
 * "Continue to Lovrican" simply dismisses — v1 is informational, and the link
 * out to adifund.com lives on the card's sponsor button.
 */
const AdifundPopupV1 = ({ show, onClose }) => (
  <Modal
    className="adifund-modal adifund-modal-v1"
    backdropClassName="adifund-backdrop"
    show={show}
    onHide={onClose}
    centered
  >
    <button
      type="button"
      className="adifund-modal-close"
      aria-label="Close"
      onClick={onClose}
    >
      <img src={closeIcon} alt="" />
    </button>
    <Modal.Body>
      <div className="adifund-v1-head">
        <p className="adifund-v1-title">
          Your Complimentary
          <br />
          Lovrican Access
        </p>
        <div className="adifund-v1-copy">
          <p className="adifund-v1-para">
            Adifund has partnered with Lovrican to provide members with free
            access to the platform.
          </p>
          <p className="adifund-v1-para">
            This exclusive benefit is included with your Adifund membership and
            is designed to help you expand your network, discover opportunities,
            and engage with a broader community.
          </p>
        </div>
      </div>

      <div className="adifund-v1-sponsor">
        <p>
          Sponsored by Adifund. Available to eligible members while the
          partnership remains active.
        </p>
      </div>

      <div className="adifund-v1-actions">
        <button type="button" className="adifund-v1-cta" onClick={onClose}>
          Continue to Lovrican
        </button>
      </div>
    </Modal.Body>
  </Modal>
);

export default AdifundPopupV1;
